<template>
    <div class="my-8 relative bg-gray-800 rounded-lg">
        <div class="h-56 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
            <img class="w-full h-full object-cover rounded-l-lg" :src="featuredOffer.image_1_url" alt="">
        </div>
        <div class="relative max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
            <div class="md:ml-auto md:w-1/2 md:pl-10">
                <h5 class="text-base font-medium uppercase tracking-wider text-gray-800 bg-yellow-500 inline-block px-2">Featured</h5>
                <h2 class="mt-2 text-white text-3xl font-light tracking-tight sm:text-4xl">{{ featuredOffer.headline }}</h2>

                <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <h3 class="text-2xl font-light text-white">{{ featuredOffer.priceDisplay }} EUR</h3>
                        <p class="text-sm text-white mb-0">
                            <span v-if="featuredOffer.listPrice" class="line-through">{{ featuredOffer.listPriceDisplay }} EUR</span> | {{ featuredOffer.discount }}% {{ lang.labels.discount_below_list_price }}
                        </p>
                    </div>
                    <div>
                        <h3 class="text-2xl font-light text-white">{{ featuredOffer.manufacturer }}</h3>
                        <p class="text-sm text-white mb-0">Hersteller</p>
                    </div>
                </div>

                <div class="mt-6">
                    <div class="block sm:inline-flex rounded-md shadow">
                        <a
                            :href="featuredOffer.link"
                            class="block sm:inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-white hover:bg-gray-50 text-center"
                        >
                            {{ lang.labels.view_offer }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    guest: Boolean,
    lang: Object,
    initFeaturedOffer: Object,
});

defineEmits(['show-register-modal']);

const featuredOffer = ref(props.initFeaturedOffer);

const showListPrice = computed(() => {
    return featuredOffer.value.discount !== 0;
});
</script>
